import { 
    URL_BASE_DOMAIN,
    USER_POOL_ID,
    CLI_ID,
 } from '../config/config'


export const URL_BASE=`https://${URL_BASE_DOMAIN}/`

// export const PMTILES_URL='https://d29yun90warqzr.cloudfront.net'
export const PMTILES_URL='https://dyx5seq8t4xlb.cloudfront.net'

export const FONT_COLOR='#FFF'
export const BG_COLOR='#000'

export const LOCAL_STORAGE_KEY = {
    PREFIX: 'CognitoIdentityServiceProvider',
    REGION: 'ap-northeast-1',
    USER_POOL_ID: USER_POOL_ID,
    CLI_ID: CLI_ID,
    LAST_AUTH: 'LastAuthUser',
    ID_TOKEN: 'idToken',
    ACCESS_TOKEN: 'accessToken',
    REFRESH_TOKEN: 'refreshToken',
}

